module.exports = __webpack_public_path__ + "media/images/lp_yazirushi-218f13975376e54a4cdfd49b940ca569.webp";